import { usePrevious } from "@chakra-ui/react";
import { userStorage } from "features/auth/AuthUtils";
import { useCallback, useEffect, useState } from "react";
import { useIntercom } from "react-use-intercom";

export const useHelpButtonOnClick = () => {
  const { show, boot, shutdown, isOpen } = useIntercom();
  const prevIsOpen = usePrevious(isOpen);

  // tracking this just in case there's more than one instance of this hook
  const [didClick, setDidClick] = useState(false);

  const onClick = useCallback(() => {
    const userData = userStorage.get();
    if (!isOpen) {
      setDidClick(true);
      boot({ email: userData?.email, userHash: userData?.intercomUserHash });
      show();
    }
  }, [boot, isOpen, show]);

  useEffect(() => {
    if (didClick && prevIsOpen && !isOpen) {
      setDidClick(false);
      // wait for animation to finish
      setTimeout(() => {
        shutdown();
      }, 1000);
    }
  }, [didClick, isOpen, prevIsOpen, shutdown]);

  return onClick;
};
